'use strict';

exports.__esModule = true;
exports.default = {
  UPDATE_MATCH: '@@found/UPDATE_MATCH',
  RESOLVE_MATCH: '@@found/RESOLVE_MATCH'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/found/lib/ActionTypes.js
// module id = 195
// module chunks = 0